var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(("attribute-output-" + (_vm.finding.findable.type.cast_type)),{tag:"component",attrs:{"findable":_vm.finding.findable}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }